import React, { useState, useEffect } from 'react';
import Input from '~~elements/Input';
import Modal from '~~elements/Modal';
import Button from '~~elements/Button';
import toast from '~~elements/Toast';
import Multilingual from '~~utils/Multilingual';
import { SeasonResource } from '~~apis/resource';
import { StyledForm } from '../styled';
import { useTournamentDispatch, useTournamentState } from '../useTournament';
import { find } from 'ramda';

const initTeamState = {
  name: '',
  city: '',
};

const CreateTeamModal = ({ isOpen, toClose, created }) => {
  const { tournamentInfo, teams } = useTournamentState();
  const tournamentDispatch = useTournamentDispatch();

  const [teamData, setTeamData] = useState({ ...initTeamState });
  const [dataChanged, setDataChanged] = useState(false);
  const [apiInProgress, setApiInProgress] = useState(false);

  useEffect(() => {
    setTeamData({ ...initTeamState });
    setDataChanged(false);
    setApiInProgress(false);
  }, [isOpen]);

  const handleInputOnChange = (e) => {
    const newTeamData = { ...teamData, [e.target.name]: e.target.value };
    setTeamData(newTeamData);
    setDataChanged(JSON.stringify(initTeamState) !== JSON.stringify(newTeamData));
  };

  const handleSubmit = (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }

    const teamName = teamData.name.trim();
    if (!teamName) {
      toast(`${Multilingual(`TEAM.NAME`)} ${Multilingual(`FORM.ERROR.IS_REQUIRED`)}`, { status: 'error' });
      return;
    }

    if (find((t) => t.name === teamName, teams)) {
      toast(`${Multilingual(`TEAM.NAME`)} ${Multilingual(`FORM.ERROR.DUPLICATE`)}`, { status: 'error' });
      return;
    }

    setApiInProgress(true);
    SeasonResource.createTournamentTeamByOrganizer({
      seasonUniqid: tournamentInfo.uniqid,
      data: {
        ...teamData,
        name: teamName,
      },
    })
      .then(({ data: newTeam }) => {
        SeasonResource.getTeams({ seasonUniqid: tournamentInfo.uniqid })
          .then(({ data: newTeams }) => {
            tournamentDispatch({ type: 'SET_TEAMS', payload: newTeams });
            setTimeout(() => {
              created(newTeam);
            }, 500);
          })
          .catch(() => {
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          })
          .finally(() => {
            toast(Multilingual(`SUCCESS.CREATE`), { status: 'success' });
          });
      })
      .catch(() => {
        toast(Multilingual(`COMMON.UNKNOWN_ERROR`), { status: 'error' });
        setApiInProgress(false);
      });
  };

  return (
    <Modal.Modal size="sm" isOpen={isOpen} outterClickBack={!dataChanged} onClickBack={toClose}>
      <Modal.ModalHeader hasBack={!dataChanged} onClickBack={toClose}>
        {`${Multilingual(`COMMON.CREATE`)} ${Multilingual(`TEAM.WORDING`)}`}
      </Modal.ModalHeader>
      <Modal.ModalBody>
        <StyledForm onSubmit={handleSubmit}>
          <div className="box">
            {/* 球隊名稱 */}
            <label>
              {Multilingual(`TEAM.NAME`)}
              <i>*</i>
            </label>
            <div className="input-field">
              <Input
                width="100%"
                name="name"
                value={teamData.name}
                onChange={handleInputOnChange}
                disabled={apiInProgress}
              />
            </div>
            {/* 球隊所屬縣市 */}
            <label>{Multilingual(`TEAM.CITY`)}</label>
            <div className="input-field">
              <Input
                width="100%"
                name="city"
                value={teamData.city}
                onChange={handleInputOnChange}
                disabled={apiInProgress}
              />
            </div>
          </div>
        </StyledForm>
      </Modal.ModalBody>
      <Modal.ModalFooter>
        {dataChanged && (
          <Button width="unset" color="red" onClick={handleSubmit} disabled={apiInProgress}>
            {Multilingual(`COMMON.CREATE`)}
          </Button>
        )}
        <Button width="unset" color="transparentWithBorder" onClick={toClose} disabled={apiInProgress}>
          {Multilingual(`COMMON.CANCEL`)}
        </Button>
      </Modal.ModalFooter>
    </Modal.Modal>
  );
};

export default CreateTeamModal;
